function hhmm () {
    this.time = null;
    this.validate = function() {
        // time in format HH:MM or HH
        var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-4])(:[0-5][0-9])?$/i;
        //console.log('validate ' + this.time);
        //console.log(regexPattern.test(this.time));
        return (this.time == null || this.time == '' || regexPattern.test(this.time));
        /*console.log('end validate ' + this.time);
        var timeValid = this.time == null || this.time == '' || regexPattern.test(this.time);
        if (timeValid) {
          return true;
        } else {
          return true;
        }*/
    };
}

function Setting (uid) {
    this.ID = null,
    this.SecretUntil = null,
    this.UID = uid,
    this.SimplifiedRingTypes = false,
    this.Mass = true,
    this.Time = true,
    this.WingLength = true,
    this.ThirdPrimary = true,
    this.Tarsus = true,
    this.HindClaw = true,
    this.BillLength = true,
    this.TotalHeadLength = true,
    this.TailLength = true,
    this.TailDifference = true,
    this.StateOfWingPoint = true,
    this.Moult = true,
    this.PlumageCode = true,
    this.Fat = true,
    this.PectoralMuscleScore = true,
    this.BroodPatch = true,
    this.CarpalCovert = true,
    this.JuvenilePatch = true,
    this.Alula = true,
    this.OldGreaterCoverts = true,
    this.PrimaryMoult = true,
    this.SecondaryMoult = true,
    this.ColMass = false,
    this.ColWingLength = false,
    this.ColProject = true,
    this.ColMethod = true,
    this.ColStation = true,
    this.ColSex = true,
    this.ColAge = true,
    this.ColStatus = false,
    this.ColCondition = false,
    this.ColCircumstances = false,
    this.ColAgeZH = false,
    this.ColSexZH = false,
    this.ColMassZH = false,
    this.ColWingLengthZH = false,
    this.ColBroodPatchZH = false,
    this.ColFatZH = false,
    this.ColCircumstancesZH = false,
    this.ColConditionZH = false,
    this.ColRetrapTypeZH = true,
    this.ColRingerZH = true,
    this.ColFounderZH = true,
    this.ColPhoto= false,
    this.TarsusMethod = null,
    this.BillMethod = null,
    this.RPExtensionLength = null,
    this.SecondRLNotchLength = null,
    this.FirstLLLength = null
}

/*
Class for time of observation - from, to, validate and error text
*/
function Time () {
    this.from = '';
    this.to = '';
    this.errorText = null,
    /* validate time */
    this.validate = function() {
        // time in format HH:MM or HH
        var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-4])(:[0-5][0-9])?$/i;
        var timeFromValid = this.from == null || this.from == '' || regexPattern.test(this.from);
        var timeToValid = this.to == null || this.to == '' || regexPattern.test(this.to);
        if (!timeFromValid || !timeToValid) {
          this.errorText = "Zadaný čas není validní! Čas musí být prázdný nebo ve formátu HH:MM";
          return true;
        } 
        else {
          var firstTimeBigger = Date.parse('01/01/2011 '+ this.from + ':00') > Date.parse('01/01/2011 '+ this.to + ':00')
          if (firstTimeBigger) {
            this.errorText = "Čas Do musí být vyšší než čas Od";
            return true;
          }
          return false;
        }
    };
};

/*
* Class for Ringing observation
*/
function Observation (scheme) {
    this.id = null,
    this.obsListId = null,
    this.ringNumber1_retrap = null,
    this.markType = 'A0',
    this.markColor = null,
    this.ringTypeObj = null,
    this.ringType1 = null,
    this.ringNumber1 = null,
    this.species = null,
    this.speciesUnknown = false,
    this.ringingScheme = scheme ? scheme : null,
    this.ringInformation = 1,
    this.additionalRingInformation = 1,
    this.ringedLeg = null,
    this.age = null,
    this.sex = '5',
    this.sexingMethod = 'U',
    this.catchingMethod = 'Z',
    this.catchingLure = 'U',
    this.isInteresting = false,
    this.verifiedByScheme = false,
    // additional marks
    this.additionalMarks = [],
    // detailed information
    this.circumstances = "20",
    this.circumstancesParent = "20",
    this.circumstancesPresumed = false,
    this.condition = 8,
    this.status = 'U',
    this.placeCode=scheme.substring(0,2) + '--',
    this.netLength=null,
    this.pullusAccuracy = null,
    this.dateAccuracy = null,
    this.coordinatesAccuracy = null,
    this.manipulated = 'U',
    this.movedBeforeEncounter = 9,
    this.pullusAge = null,
    this.note = null;
    this.photoId = null;
    this.photoPath = null;
    this.photoName = null;
    this.lastChange = null;
    this.lastChangeDiff = null;
    // biometrics
    this.wingLength = null,
    this.thirdPrimary = null,
    this.mass = null,
    this.time = null,
    this.hindClaw = null,
    this.billLength = null,
    this.billMethod = null,
    this.totalHeadLength = null,
    this.tarsus = null,
    this.tarsusMethod = null,
    this.tailLength = null,
    this.tailDifference = null,
    this.firstLLLength = null,
    this.rPExtensionLength = null,
    this.secondRLNotchLength = null,
    // qualitative data
    this.stateOfWingPoint = 'U',
    this.moult = 'U',
    this.plumageCode = 'U'
    this.fat = null,
    this.pectoralMuscleScore = null,
    this.broodPatch = null,
    this.juvenilePatch = null,
    this.oldGreaterCoverts = null,
    this.carpalCovert = null,
    this.primaryMoult = {
        v1: null,
        v2: null,
        v3: null,
        v4: null,
        v5: null,
        v6: null,
        v7: null,
        v8: null,
        v9: null,
        v10: null
    },
    this.secondaryMoult = {
        v1: null,
        v2: null,
        v3: null,
        v4: null,
        v5: null,
        v6: null
    },
    this.alula = {
        v1: null,
        v2: null,
        v3: null
    },
    this.kipp = null;
    this.family = new Family();
    this.newFamily = false;
    this.bloodSample = false;
    this.featherSample = false;
    // ras
    this.ras = false;
    this.rasProjNumber = null;
    this.rasCheckNumber = null;
    this.rasDuration = null;
    // ces
    this.ces = false;
    this.cesProjNumber = null;
    this.cesCheckNumber = null;
    this.cesNetNumber = null;
    this.cesNetLength = null;
    this.cesMoult = null;
    this.cesHabitat = null;
    this.cesWeightingTime = null;
    // mlynarik
    this.aegithalosHead = null;

    this.copyOf = function() {
        var copy = new Observation(this.ringingScheme);
        copy.obsListId = this.obsListId;
        // mark type
        copy.markType = this.markType;
        // copy ring information
        copy.ringInformation = this.ringInformation;
        copy.additionalRingInformation = this.additionalRingInformation;
        // copy ring type only for new ringing
        if (copy.ringInformation == 1){
            copy.ringNumber1 = this.ringNumber1;
            copy.ringType1 = this.ringType1;
            copy.ringTypeObj = {
                ID_RingType: this.ringTypeObj.ID_RingType,
                first: this.ringTypeObj.min
            };
        }
        copy.ringingScheme = this.ringingScheme;    
        copy.additionalRingInformation = copy.additionalRingInformation;
        //copy.ringNumber1 = Number(this.ringNumber1) + 1;
        copy.markColor = this.markColor;
        copy.species = this.species;
        copy.age = this.age;
        // copy pullus age and accuracy, if pullus
        if (this.age && this.age.toString() === "200"){
            copy.pullusAge = this.pullusAge;
            copy.pullusAccuracy = this.pullusAccuracy;
        }
        copy.circumstancesParent = this.circumstancesParent;
        copy.circumstances = this.circumstances;
        copy.sex = this.sex;
        copy.sexingMethod = this.sexingMethod;
        copy.catchingMethod = this.catchingMethod;
        copy.catchingLure = this.catchingLure;
        copy.status = this.status;
        copy.placeCode = this.placeCode;
        copy.movedBeforeEncounter = this.movedBeforeEncounter;
        copy.manipulated = this.manipulated;
        copy.time = this.time;
        // copy accuaracy of coordinates and date
        copy.dateAccuracy = this.dateAccuracy;
        copy.coordinatesAccuracy = this.coordinatesAccuracy;
        // ces
        copy.ces = this.ces;
        copy.cesProjNumber = this.cesProjNumber;
        copy.cesCheckNumber = this.cesCheckNumber;
        copy.cesHabitat = this.cesHabitat;
        copy.cesNetLength = this.cesNetLength;
        // ras
        copy.ras = this.ras;
        copy.rasProjNumber = this.rasProjNumber;
        copy.rasCheckNumber = this.rasCheckNumber;
        copy.rasDuration = this.rasDuration;
        // mlynarik
        copy.aegithalosHead = null;
        return copy;
    }
};

function Family () {
    this.ID = null,
    this.itemId = null,
    this.Description = null,
    this.Closed = false,
    this.NumBirds = null,
    this.ringed = null,
    this.NestNumber = null,
    this.role = 'sibling';
};

/*
* account movement
*/
function AccountMovement () {
    this.ID = null,
    this.UID = null,
    this.Year = (new Date()).getFullYear(),
    this.DateProcessed = new Date(),
    this.Amount = null,
    this.Subject = null,
    this.Description = null
};

/*
Class for additional mark
*/
function Mark (obj) {
    this.id = null,
    this.markType = null,
    this.ringInformation = null,
    this.additionalRingInformation = 1,
    this.ringingScheme = null,
    this.markColor = null,
    this.ringNumber_retrap = null,
    this.ringType = null,
    this.ringNumber = null
};

/*
Class for locality
*/
function Locality (obj) {
    this.ID = 0,
    this.Name = null,
    this.Municipality = null,
    this.KODCOBE = null,
    this.ID_MunicipalityPart = null,
    this.CountryText = null,
    //this.latitude = null,
    //this.longitude = null,
    this.Note = null,
    this.coords = {longitude: null, latitude: null},
    this.crdsText = null;
    /* Human readable representation of coordinates */
    /*this.toCoordsText = function() {
        if (!this.coords.latitude || !this.coords.longitude) return null;
        return this.coords.latitude.toFixed(5) + ', ' + this.coords.longitude.toFixed(5);
    }*/

    /* validate */
    this.validate = function(){
        // mandatory fields
        if ((this.ID == null) || (this.Name == null) || (this.Name.length == 0) 
            || (this.Municipality == null) || (this.Municipality.length == 0)
            || (this.ID_MunicipalityPart == null)){
            return false;
        }
        // coordinates are numbres?
        if(!isNumber(this.coords.latitude) || !isNumber(this.coords.longitude)){
            return false;
        }
        return true;
    }
    
    // fill instance of locality from JSON object
    for (var prop in obj) this[prop] = obj[prop];
};

/*
Class for RingOrder
*/
function RingOrder () {
    this.ID = null,
    this.Radius = null,
    this.Amount = null,
    this.Status = null,
    this.Changed = false,
    this.RingType = {Code:null,Radius:null,MaxValue:null},
    this.FromValue = null,
    this.ToValue = null,
    this.DateCreated = null,
    this.DateProcessed = null,
    this.DateClosed = null,
    this.errorText = null,
    this.Step = null;
    this.Discount = null;
    this.DiscountReason = null;

    // validate order on User side
    this.validateUserOrder = function() {
        if (!this.Radius || !this.Amount) { 
            return false;
        } else if (!isNumber(this.Radius.replace(",",'.')) || !isInt(this.Amount)) {
            this.errorText = "Hodnoty POLOMĚR a MNOŽSTVÍ musí být čísla";
            return true;
        } else if (parseFloat(this.Radius.replace(",",".")) <= 0 || parseInt(this.Amount) <= 0) {
            this.errorText = "Hodnoty POLOMĚR a MNOŽSTVÍ musí být větší než 0";
            return true;
        } else {
            this.errorText = null;
            return false;
        }
    },

    // validate order on Admin side - when inserting rings into DB
    this.validateInsertRings = function() {
        if (!this.RingType.Code || !this.RingType.Maxvalue || !this.FromValue || !this.ToValue) { 
            return false;
        } else if (!isInt(this.FromValue) || !isInt(this.ToValue)) {
            this.errorText = "Hodnoty OD a DO musí být čísla";
            return true;
        } else if (parseInt(this.FromValue) <= 0) {
            this.errorText = "Hodnota OD musí být větší než 0";
            return true;
        } else if (parseInt(this.ToValue) < parseInt(this.FromValue)) {
            this.errorText = "Hodnota OD musí být menší než hodnota DO";
            return true;
        } else if (parseInt(this.ToValue) > parseInt(this.RingType.MmaxValue)) {
            this.errorText = "Hodnota DO je větší nez nejvyšší povolená hodnota pro danou sérii";
            return true;
        } else {
            this.errorText = null;
            return false;
        }
    },

    // validate order on Admin side, if from is > 0 and to <= maxValue
    this.validateAdminOrder = function() {
        if (!this.RingType.Code || !this.RingType.Maxvalue || !this.FromValue || !this.toValue) { 
            return false;
        } else if (!isInt(this.FromValue) || !isInt(this.toValue)) {
            this.errorText = "Hodnoty OD a DO musí být čísla";
            return true;
        } else if (parseInt(this.FromValue) <= 0) {
            this.errorText = "Hodnota OD musí být větší než 0";
            return true;
        } else if (parseInt(this.toValue) < parseInt(this.FromValue)) {
            this.errorText = "Hodnota OD musí být menší než hodnota DO";
            return true;
        } else if (parseInt(this.toValue) > parseInt(this.ringType.maxValue)) {
            this.errorText = "Hodnota DO je větší nez nejvyšší povolená hodnota pro danou sérii";
            return true;
        } else if ((this.FromValue - this.ToValue) != this.Amount) {
            this.errorText = "Počet vydaných kroužků neodpovídá počtu objednaných";
            return true;
        } else {
            this.errorText = null;
            return false;
        }
    }
};


/*
Class for RingRegistration
*/
function RingRegistration () {
    this.ringType = {"Code": null, "Maxvalue":null, "Material":null, "Radius":null},
    this.from = null,
    this.to = null,
    this.withDuplicates = false,
    this.allowDuplicates = false,
    this.errorText = null,

    // validate, if from is > 0 and to <= maxValue
    this.validate = function() {
        if (!this.ringType.Code || !this.ringType.Maxvalue || !this.from || !this.to) { 
            return false;
        } else if (!isInt(this.from) || !isInt(this.to)) {
            this.errorText = "Hodnoty OD a DO musí být čísla";
            return true;
        } else if (parseInt(this.from) <= 0) {
            this.errorText = "Hodnota OD musí být větší než 0";
            return true;
        } else if (parseInt(this.to) < parseInt(this.from)) {
            this.errorText = "Hodnota OD musí být menší než hodnota DO";
            return true;
        } else if (parseInt(this.to) > parseInt(this.ringType.maxValue)) {
            this.errorText = "Hodnota DO je vetsi nez nejvyssi povolena hodnota pro danou serii";
            return true;
        } else {
            this.errorText = null;
            return false;
        }
    }
};
